namespace TabAurous.Administration {
    export interface APIKeysForm {
        ClientId: Serenity.StringEditor;
        AppName: Serenity.StringEditor;
        Role: Serenity.LookupEditor;
        Button: ButtonEditor;
        Key: Serenity.StringEditor;
        Secret: Serenity.PasswordEditor;
    }

    export class APIKeysForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.APIKeys';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!APIKeysForm.init)  {
                APIKeysForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = ButtonEditor;
                var w3 = s.PasswordEditor;

                Q.initFormType(APIKeysForm, [
                    'ClientId', w0,
                    'AppName', w0,
                    'Role', w1,
                    'Button', w2,
                    'Key', w0,
                    'Secret', w3
                ]);
            }
        }
    }
}
